import React, { FC } from 'react';
import loadable from '@loadable/component';
import { Div } from 'ui-kit';
import { CircularProgress } from '@material-ui/core';

const Loading = () => <div>Loading....</div>;

// Full-width centred spinner for a page that can't render its content yet - a route still resolving
// its guard, or a page waiting on the request that supplies its props.
export const PageLoading: FC = () => (
  <Div alignItems="center" display="flex" justifyContent="center" margin={{ top: 50 }} width="100%">
    <CircularProgress />
  </Div>
);

export const baseLoader = (importState: () => any) => loadable(importState, { fallback: <Loading /> });
